export default __webpack_public_path__ + "static/media/Tracking_Y_Triangle.797483c5.svg";